<template>
  <div
    v-if="reviewData"
    class="card-timeline--uniform review card-review-detail"
    :class="[{ 'expert-review': isExpertReview }, { 'is-expert': isExpertReview }]"
  >
    <p class="time">{{ reviewData.created_at | relativeTimeEn }}</p>
    <div class="available-share">
      <div class="card-userinfo--uniform">
        <GImageUser
          :user="reviewData.user"
          :username="reviewData.user.user_name || null"
          :src="reviewData.user.image"
          class="img-user"
          class-name="avatar"
          :alt="reviewData.user.user_name || 'icon-default-avatar'"
          :user-level="reviewData.user.user_level"
          :is-expert-review="isExpertReview"
        />

        <div class="userinfo">
          <div class="userinfo-name">
            <a
              :href="`${$store.state.SOCO_WEB_URL}/${reviewData.user.user_name}/timeline`"
              target="_blank"
              rel="noopener"
            >
              <h4 v-if="reviewData.user && reviewData.user.name" class="username">{{ reviewData.user.name }}</h4>
              <h4 v-else-if="reviewData.user && reviewData.user.user_name" class="username">
                {{ reviewData.user.user_name }}
              </h4>
            </a>
            <span
              v-if="
                isExpertReview &&
                reviewData.user.is_expert_reviewer &&
                reviewData.user.expert_role &&
                $route.name === 'Dashboard'
              "
              class="label-profile"
              >{{ convertName(reviewData.user.expert_role) }}</span
            >
          </div>
          <div class="userinfo-detail">
            <SkinTypesV2 v-if="showSkinTypes" :skin-types="reviewData.user.skin_types" />
            <template v-else>
              <HairTypesV2 :hair-types="reviewData.user.hair_types"></HairTypesV2>
            </template>
            <!-- <span class="time">{{ reviewData.created_at | relativeTime }}</span>
            <span class="bullet"></span>
            <template v-if="reviewData.user.age_range">
              <span class="age-range"> {{ reviewData.user.age_range }} </span>
              <span class="bullet"></span>
            </template> -->
            <!-- <template v-if="!isIndonesianSource">
						<SvgImg width="20" height="14" name="vn" class="country" alt="Sociolla"/>
						<span class="bullet"></span>
					</template> -->
            <!-- <GUserLevel :userlevel="reviewData.user.user_level || 'soco member'" /> -->
            <!-- <span class="bullet"></span> -->
            <!-- <a :href="`${$store.state.SOCO_WEB_URL}/${reviewData.user.user_name}/timeline?k=2`" target="_blank" rel="noopener noreferrer" class="see-all-user-review">See all user’s review</a> -->
          </div>
          <!-- <div
            v-else-if="!isExpertReview && reviewData.user && reviewData.user.expert_role && $route.name !== 'Dashboard'"
            class="expert-role"
          >
            {{ reviewData.user.expert_role | upperCase }}
          </div> -->
        </div>
        <!-- <template v-if="showSkinTypes">
          <div class="mt-7">
            <SkinTypes :skin-types="reviewData.user.skin_types" />
          </div>
        </template>
        <template v-else>
          <div class="mt-7">
            <HairTypes :hair-types="reviewData.user.hair_types" />
          </div>
        </template> -->
      </div>

      <!-- <template v-if="!isDesktop">
        <span
          v-if="showBookmark && isLogin"
          class="btn-action journal-icon--uniform bookmark"
          :class="{ active: reviewData.has_bookmarked }"
          @click="bookmark(reviewData.newsfeed_id)"
        ></span>
        <span
          v-else-if="showBookmark"
          class="btn-action journal-icon--uniform bookmark"
          :class="{ active: reviewData.has_bookmarked }"
          @click="loginOtf"
        ></span>
      </template> -->

      <div class="card-content">
        <GProduct
          v-if="showProduct && isDesktop"
          class-modifier="product--minimalist"
          :product="reviewData.product"
          :right-btn-review="true"
          :hide-price="true"
          :inline-reviewers="true"
          :object_type="object_type"
          @click.native="saveSearchHistoryClicks(reviewData.product.id, 'product')"
        />

        <div class="right-content">
          <div
            v-if="
              isExpertReview &&
              ((reviewData.user && reviewData.user.is_expert_reviewer) ||
                (reviewData.owner && reviewData.owner.is_expert_reviewer))
            "
            class="trusted-review hidden-md hidden-lg"
          >
            <!-- <img src="/assets/img/expert-review-label-mobile.svg" alt="expert-review" height="20" width="110" /> -->
          </div>
          <!-- <div v-else-if="reviewData.is_verified_purchase" class="trusted-review hidden-md hidden-lg">
            <span v-tooltip.bottom-start="tooltipOptions">
              <img src="/assets/img/icons/trusted-review.svg" class="trusted-review__icon" />
              <SvgImg
                v-if="isDesktop"
                id="trusted-review"
                name="trusted-review"
                class="trusted-review__icon"
                width="23"
                height="20"
              />
              <SvgImg
                v-else
                id="trusted-review"
                name="trusted-review"
                class="trusted-review__icon"
                width="14"
                height="12"
              />
              <span class="trusted-review__text text-uppercase">TRUSTED REVIEW</span>
            </span>
          </div> -->
          <span class="collapsible hidden-md hidden-lg" :class="{ active: collapsed == true }" @click="toggle"></span>

          <div class="container-rating-new">
            <GRatingInline
              v-if="averageRatingUser"
              class-modifier="average-rating--uniform"
              :average-rating="averageRatingUser.toFixed(1)"
              :star-fill-number="starFillNumber"
            />
            <img
              v-if="reviewData.user.is_expert_reviewer"
              class="label-expert"
              src="/assets/img/expert-review-label-v2.svg"
              alt=""
              height="16"
              width="16"
            />
            <img
              v-else-if="!reviewData.user.is_expert_reviewer && reviewData.is_verified_purchase"
              class="label-expert"
              src="/assets/img/icon-shopper-label-v2.svg"
              alt=""
              height="16"
              width="16"
            />
          </div>

          <!-- <div
            v-if="reviewData.is_verified_purchase"
            v-tooltip.bottom-start="tooltipOptions"
            class="trusted-review hidden-xs hidden-sm"
          >
            <img src="/assets/img/icons/trusted-review.svg" class="trusted-review__icon" alt="icon-trusted-review" />
            <span class="trusted-review__text text-uppercase">TRUSTED REVIEW</span>
          </div> -->

          <template v-if="isDesktop">
            <div>
              <div class="row-rate-detail d-flex">
                <div v-if="reviewData.star_packaging" class="rate-col">
                  <p>
                    <span class="rate-pink" :class="{ white: reviewData.user.is_expert_reviewer }">{{
                      `${reviewData.star_packaging.toFixed()}/5`
                    }}</span>
                    <span class="text-rate">Packaging</span>
                  </p>
                </div>
                <div v-if="reviewData.star_eficiency" class="rate-col">
                  <p>
                    <span class="rate-pink" :class="{ white: reviewData.user.is_expert_reviewer }">{{
                      `${reviewData.star_eficiency.toFixed()}/5`
                    }}</span>
                    <span class="text-rate">Efficiency</span>
                  </p>
                </div>
                <div v-if="reviewData.star_durability" class="rate-col">
                  <p>
                    <span class="rate-pink" :class="{ white: reviewData.user.is_expert_reviewer }">{{
                      `${reviewData.star_durability.toFixed()}/5`
                    }}</span>
                    <span class="text-rate">Durability</span>
                  </p>
                </div>
                <div v-if="reviewData.star_pigmentation" class="rate-col">
                  <p>
                    <span class="rate-pink" :class="{ white: reviewData.user.is_expert_reviewer }">{{
                      `${reviewData.star_pigmentation.toFixed()}/5`
                    }}</span>
                    <span class="text-rate">Pigmentation</span>
                  </p>
                </div>
                <div v-if="reviewData.star_long_wear" class="rate-col">
                  <p>
                    <span class="rate-pink" :class="{ white: reviewData.user.is_expert_reviewer }">{{
                      `${reviewData.star_long_wear.toFixed()}/5`
                    }}</span>
                    <span class="text-rate">Long Wear</span>
                  </p>
                </div>
                <div v-if="reviewData.star_effectiveness" class="rate-col">
                  <p>
                    <span class="rate-pink" :class="{ white: reviewData.user.is_expert_reviewer }">{{
                      `${reviewData.star_effectiveness.toFixed()}/5`
                    }}</span>
                    <span class="text-rate">Effectiveness</span>
                  </p>
                </div>
                <div v-if="reviewData.star_texture" class="rate-col">
                  <p>
                    <span class="rate-pink" :class="{ white: reviewData.user.is_expert_reviewer }">{{
                      `${reviewData.star_texture.toFixed()}/5`
                    }}</span>
                    <span class="text-rate">Texture</span>
                  </p>
                </div>
                <div v-if="reviewData.star_value_for_money" class="rate-col">
                  <p>
                    <span class="rate-pink" :class="{ white: reviewData.user.is_expert_reviewer }">{{
                      `${reviewData.star_value_for_money.toFixed()}/5`
                    }}</span>
                    <span class="text-rate">Value for Money</span>
                  </p>
                </div>
              </div>

              <div class="row-rate-detail d-flex b-dashed">
                <div class="rate-col m-right">
                  <p class="mb-12 text-purchased">
                    <span class="lato_regular">Recommend this product?</span
                    ><span class="bigger">{{ recommendText }}</span>
                  </p>
                </div>
                <div class="rate-col m-right">
                  <p class="mb-12 text-purchased">
                    <span class="lato_regular">Repurchase this product?</span
                    ><span class="bigger">{{ repurchasedText }}</span>
                  </p>
                </div>
                <div v-if="reviewData.duration_of_used" class="rate-col">
                  <p class="mb-12 text-purchased">
                    <span class="lato_regular">Usage Period</span
                    ><span class="bigger">{{ reviewData.duration_of_used }}</span>
                  </p>
                </div>
              </div>
              <span
                v-if="reviewData.product.variant"
                class="review-variant-pro"
                :class="{ 'expert-review': reviewData.user.is_expert_reviewer }"
                >{{ reviewData.product.variant }}</span
              >
              <span
                v-else-if="reviewData.product.combination"
                class="review-variant-pro"
                :class="{ 'expert-review': reviewData.user.is_expert_reviewer }"
                v-html="showProductDetail(reviewData.product.combination)"
              ></span>
            </div>
          </template>

          <template v-else>
            <div v-show="collapsed">
              <div class="row-rate-detail d-flex score">
                <div v-if="reviewData.star_packaging" class="rate-col">
                  <p>
                    <span class="rate-pink">{{ `${reviewData.star_packaging.toFixed()}/5` }}</span>
                    <span class="text-rate">Packaging</span>
                  </p>
                </div>
                <div v-if="reviewData.star_eficiency" class="rate-col">
                  <p>
                    <span class="rate-pink">{{ `${reviewData.star_eficiency.toFixed()}/5` }}</span>
                    <span class="text-rate">Efficiency</span>
                  </p>
                </div>
                <div v-if="reviewData.star_durability" class="rate-col">
                  <p>
                    <span class="rate-pink">{{ `${reviewData.star_durability.toFixed()}/5` }}</span>
                    <span class="text-rate">Durability</span>
                  </p>
                </div>
                <div v-if="reviewData.star_pigmentation" class="rate-col">
                  <p>
                    <span class="rate-pink">{{ `${reviewData.star_pigmentation.toFixed()}/5` }}</span>
                    <span class="text-rate">Pigmentation</span>
                  </p>
                </div>
                <div v-if="reviewData.star_long_wear" class="rate-col">
                  <p>
                    <span class="rate-pink">{{ `${reviewData.star_long_wear.toFixed()}/5` }}</span>
                    <span class="text-rate">Long Wear</span>
                  </p>
                </div>
                <div v-if="reviewData.star_effectiveness" class="rate-col">
                  <p>
                    <span class="rate-pink">{{ `${reviewData.star_effectiveness.toFixed()}/5` }}</span>
                    <span class="text-rate">Effectiveness</span>
                  </p>
                </div>
                <div v-if="reviewData.star_texture" class="rate-col">
                  <p>
                    <span class="rate-pink">{{ `${reviewData.star_texture.toFixed()}/5` }}</span>
                    <span class="text-rate">Texture</span>
                  </p>
                </div>
                <div v-if="reviewData.star_value_for_money" class="rate-col">
                  <p>
                    <span class="rate-pink">{{ `${reviewData.star_value_for_money.toFixed()}/5` }}</span>
                    <span class="text-rate">Value for Money</span>
                  </p>
                </div>
              </div>

              <div class="row-rate-detail d-flex b-dashed pt-16">
                <div class="rate-col text-purchased">
                  <p class="mb-12">
                    <span class="lato_regular_12">Recommend</span> <br />
                    <span class="bigger">{{ recommendText }}</span>
                  </p>
                </div>
                <div class="rate-col text-purchased">
                  <p class="mb-12">
                    <span class="lato_regular_12">Repurchase</span> <br />
                    <span class="bigger">{{ repurchasedText }}</span>
                  </p>
                </div>
                <div v-if="reviewData.duration_of_used" class="rate-col text-purchased">
                  <p class="mb-12">
                    <span class="lato_regular_12">Usage Period</span> <br />
                    <span class="bigger">{{ reviewData.duration_of_used }}</span>
                  </p>
                </div>
              </div>
            </div>
            <template v-if="showProduct">
              <GProductSociolla
                v-if="isExpertReview && reviewData.product"
                class="product--inline"
                :class="{ 'expert-review': isExpertReview }"
                :inline-reviewers="reviewData.product.review_stats ? reviewData.product.review_stats.total_reviews : 0"
                :button-review="true"
                :product="reviewData.product"
                :is-expert-review="isExpertReview"
                button-shop
                hide-total-reviews
              />
              <GProduct
                v-else
                class-modifier="product--minimalist"
                :product="reviewData.product"
                :right-btn-review="true"
                :hide-price="true"
                :inline-reviewers="true"
                :object_type="object_type"
                @click.native="saveSearchHistoryClicks(reviewData.product.id, 'product')"
              />
            </template>
            <span v-if="reviewData.product.variant" class="review-variant-pro">{{ reviewData.product.variant }}</span>
            <span
              v-else-if="reviewData.product.combination"
              class="review-variant-pro"
              v-html="showProductDetail(reviewData.product.combination)"
            ></span>
          </template>

          <!-- <ProductAttributes
	        	v-if="reviewData.product && reviewData.product.combination"
	        	:attributes="reviewData.product.combination"
	        /> -->

          <div v-if="String(reviewData.details).length > 150" class="review-content--text">
            <div v-if="seeMoreDetailsOpen">
              <p class="review-text">
                <span>{{ reviewData.details }}</span>
                <span class="review-read-more" @click.prevent="toggleSeeMore">(Read less)</span>
              </p>
            </div>
            <div v-else>
              <p class="review-text">
                <span>{{ reviewData.details | trimRecentReviewContentMobile }}</span>
                <span class="review-read-more" @click.prevent="toggleSeeMore">(Read more)</span>
              </p>
            </div>
          </div>
          <div v-else class="review-content--text">
            <p class="review-text">{{ reviewData.details }}</p>
          </div>

          <template v-if="!isDesktop">
            <span v-if="ownerOfReview && reviewData.edited_at" class="text-edit">
              (edited at {{ reviewData.updated_at | dateMonthYear }})
            </span>
            <span
              v-else-if="ownerOfReview && !reviewData.edited_at && !reviewData.hasOwnProperty('is_editable')"
              class="text-edit"
            >
              (edit)
            </span>
          </template>

          <ListUserPhoto
            v-if="$SO.size(reviewData.images)"
            :key="`list-user-photo-${reviewData['_id']}`"
            :average-rating="reviewData.average_rating ? reviewData.average_rating : 0"
            :details="reviewData.details ? reviewData.details : ''"
            :images="reviewData.images"
            :created_at="reviewData.created_at"
            :user="reviewData.user"
          />
        </div>
      </div>
    </div>
    <!-- List of Likers -->
    <!-- <div v-if="likers && likers.likes && likers.likes.length" class="helpful-pro">
      <template v-for="(like, key) in likers.likes">
        <template>
          <a :key="key" :href="`${$store.state.SOCO_WEB_URL}/${like.user.user_name}/timeline`" target="_blank" rel="noopener">
            <img v-if="like.user.image" :src="ownerImage(like.user.image)" class="avatar" :alt="like.user.user_name" />
            <img v-else src="/assets/img/default-avatar.png" class="avatar" alt="icon-default-avatar" />
          </a>
        </template>
      </template>
      <template v-if="likers.total_likes > 5">
        <span class="review-help-pro">+{{ likers.total_likes - 5 }}</span>
      </template>
      <div v-if="likers.total_likes > 5" class="helpful-title">found this helpful</div>
    </div> -->

    <div class="action-bottom-card-timeline--uniform">
      <div class="left review-likes">
        <span
          v-if="isLogin"
          class="btn-action journal-icon--uniform helpful"
          :class="{ active: reviewData.has_liked }"
          @click="like(reviewData.newsfeed_id)"
          >Helpful {{ likers.total_likes ? `(${likers.total_likes})` : '' }}</span
        >
        <span
          v-else
          class="btn-action journal-icon--uniform helpful"
          :class="{ active: reviewData.has_liked }"
          @click="loginOtf"
          >Helpful {{ likers.total_likes ? `(${likers.total_likes})` : '' }}</span
        >
        <span
          v-if="showBookmark && isLogin && isDesktop"
          class="btn-action journal-icon--uniform bookmark"
          :class="{ active: reviewData.has_bookmarked }"
          @click="bookmark(reviewData.newsfeed_id)"
          >Bookmark</span
        >
        <span
          v-else-if="showBookmark && isDesktop"
          class="btn-action journal-icon--uniform bookmark"
          :class="{ active: reviewData.has_bookmarked }"
          @click="loginOtf"
          >Bookmark</span
        >
        <span class="btn-action journal-icon--uniform share" @click.prevent="modalShare()">Share</span>
        <!-- <span class="btn-action journal-icon--uniform share" @click.prevent="toggleShare()" v-if="!isOpenShareDropdown">Share</span> -->
      </div>
      <div class="right">
        <template v-if="isDesktop">
          <span
            v-if="ownerOfReview && reviewData.edited_at && reviewData.hasOwnProperty('is_editable')"
            class="text-edit"
          >
            (edited at {{ reviewData.updated_at | dateMonthYear }})
          </span>
          <span
            v-else-if="ownerOfReview && reviewData.edited_at && !reviewData.hasOwnProperty('is_editable')"
            class="text-edit"
          >
            (edit)
          </span>
        </template>

        <template v-if="ownerOfReview && isLogin">
          <a href="" class="journal-icon--uniform more" @click.prevent="toggleDropdown"></a>
          <div v-if="isOpenDropdown" class="action-top-card-dropdown--uniform active">
            <a v-if="ownerOfReview && reviewData.is_editable" href="" @click.prevent="editReview">
              <span class="journal-icon--uniform edit">Edit Review</span>
            </a>
            <a v-if="ownerOfReview && isLogin" href="" @click.prevent="requestToDelete(reviewData.newsfeed_id)">
              <span class="journal-icon--uniform request-delete">Request to Delete</span>
            </a>
            <!-- <a href="" @click.prevent="" v-if="reviewData.has_reported && isLogin">
						<span class="journal-icon--uniform reported">Reported Already</span>
					</a>
					<a href="" @click.prevent="openModalReport" v-else-if="!reviewData.has_reported && isLogin">
						<span class="journal-icon--uniform report">Report</span>
					</a>
					<a href="" @click.prevent="loginOtf" v-else>
						<span class="journal-icon--uniform report">Report</span>
					</a> -->
          </div>
        </template>
        <div v-else class="journal-icon--uniform report">
          <a v-if="reviewData.has_reported && isLogin" href="" @click.prevent=""> </a>
          <a v-else-if="!reviewData.has_reported && isLogin" href="" @click.prevent="openModalReport"> </a>
          <a v-else href="" @click.prevent="loginOtf"> </a>
        </div>
      </div>

      <!-- <ShareSosmed
			v-if="reviewData.product"
			:isOpen="isOpenShareDropdown"
			:id="reviewData.newsfeed_id"
			:product="reviewData.product"
	    	@onChange="toggleShare"
	    /> -->
    </div>
  </div>
</template>

<script>
// import SkinTypes from './skin-types/skin-types';
// import HairTypes from './hair-types/hair-types';
import SkinTypesV2 from './skin-types/skin-types-v2';
import HairTypesV2 from './hair-types/hair-types-v2';
// import ProductAttributes from './product-attributes';
import ListUserPhoto from './list-user-photo';
// import ShareSosmed from '@/components/global/share-sosmed/share-sosmed';
const Config = require('~/config/default.env').default;
import Auth from '@/shared/auth';

export default {
  name: 'CardReviewDetail',
  components: {
    SkinTypesV2,
    HairTypesV2,
    // ProductAttributes,
    ListUserPhoto,
    // ShareSosmed,
  },
  props: {
    reviewData: {
      type: Object,
      required: true,
    },
    showProduct: {
      type: Boolean,
      required: false,
      default: true,
    },
    showBookmark: {
      type: Boolean,
      required: false,
      default: false,
    },
    on: {
      type: String,
      required: true,
    },
    isExpertReview: {
      type: Boolean,
      default: false,
    },
    object_type: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      likers: {
        likes: [],
        total_likes: 0,
      },
      isOpenDropdown: false,
      isOpenShareDropdown: false,
      seeMoreDetailsOpen: false,
      isLoadingFinishListUserPhoto: false,
      listUserPhoto: '',
      collapsed: false,
      isLoadingLikeReview: false,
    };
  },
  computed: {
    isIndonesianSource() {
      return !/vn/gi.test(this.reviewData.source);
    },
    showSkinTypes() {
      return Boolean(
        (this.$SO.size(this.reviewData.product.parent_category) &&
          this.reviewData.product.parent_category.name !== 'Hair Care') ||
          (this.$SO.size(this.reviewData.product.categories) &&
            this.reviewData.product.categories[0].name != 'Hair Care')
      );
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    averageRatingUser() {
      let averageRatingUser = 0;
      let sumRatingUser = 0;
      let sumGiveRating = 0;
      this.$SO.each(this.reviewData, (prop, val) => {
        if (/star_/.test(prop) && val) {
          sumRatingUser += val;
          sumGiveRating++;
        }
      });
      averageRatingUser = sumRatingUser / sumGiveRating;
      return averageRatingUser;
    },
    tooltipOptions() {
      const triggerValue = this.screen.isDesktop ? 'hover' : 'click';
      const placementValue = this.screen.isDesktop ? 'bottom-start' : 'bottom-start';
      return {
        content:
          'Review terpercaya dari user yang membeli produk kecantikan di Sociolla atau mendapatkan produk kecantikan dari program sampling kami',
        trigger: triggerValue,
        placement: placementValue,
      };
    },
    imgSrc() {
      return this.$SO.size(this.reviewData.user) ? this.reviewData.user.image : null;
    },
    isLogin() {
      return this.$SO.size(this.$store.state.auth.userProfile);
    },
    ownerOfReview() {
      return this.reviewData.user.id === (this.$store.state.userProfile && this.$store.state.userProfile._id);
    },
    repurchasedText() {
      if (this.reviewData.is_repurchase == 'yes') {
        return 'Yes';
      } else if (this.reviewData.is_repurchase == 'no') {
        return 'No';
      } else {
        return 'Maybe';
      }
    },
    recommendText() {
      if (this.reviewData.is_recommended == 'yes') {
        return 'Yes';
      } else {
        return 'No';
      }
    },
    screen() {
      return this.$store.state.screen;
    },
    showProductAttribute() {
      if (this.reviewData.product && this.reviewData.product.variant) {
        return !/non specify/.test(this.reviewData.product.variant.toLowerCase());
      } else if (this.reviewData.product && this.reviewData.product.combination) {
        return true;
      } else {
        return false;
      }
    },
    starFillNumber() {
      const starFillNumber = this.$options.filters.rating(this.averageRatingUser) * 10;
      return starFillNumber ? starFillNumber : 0;
    },
    idUser() {
      return this.$store.state.userProfile._id;
    },
  },
  created() {
    this.likers = {
      likes: this.reviewData.likes ? [...this.reviewData.likes] : [],
      total_likes: this.reviewData.total_likes ? this.reviewData.total_likes : 0,
    };
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
  },
  methods: {
    notCompletedDetailProfile() {
      return !Boolean(
        this.reviewData.user.hasOwnProperty('skin_types') || this.reviewData.user.hasOwnProperty('hair_types')
      );
    },
    toggle() {
      this.collapsed = !this.collapsed;
    },
    documentClick(e) {
      const target = e.target;
      if (this.isOpenDropdown) {
        if (this.$SO(target).closest('.journal-icon--uniform').length < 1) {
          this.isOpenDropdown = false;
        }
      }
    },
    ageRange(birthdate) {
      const getAge = Math.floor((new Date() - new Date(birthdate).getTime()) / 3.15576e10);
      return this.$options.filters.rangeForAge(getAge);
    },
    bookmarkAction(reviewId, value) {
      if (this.on === 'expert-page') {
        this.$emit('set-bookmark', {
          value,
          reviewId,
        });
      } else {
        this.$store.commit('review/SET_HAS_BOOKMARKED', {
          on: this.on,
          value,
          reviewId,
        });
      }
    },
    bookmark(id) {
      this.bookmarkAction(this.reviewData._id, !this.reviewData.has_bookmarked);

      this.$MS_SOCO_PUBLIC_API_URL
        .post(`/newsfeed/${id}/bookmarks`)
        .then((response) => {
          if (response.status !== 200) {
            this.bookmarkAction(this.reviewData._id, !this.reviewData.has_bookmarked);
          }
        })
        .catch((err) => {
          this.bookmarkAction(this.reviewData._id, !this.reviewData.has_bookmarked);
        });
    },
    editReview() {
      this.$store.dispatch('userBlockedToReviewCheck').then((isBlocked) => {
        if (isBlocked) {
          return;
        }
        const review = JSON.parse(JSON.stringify(this.reviewData));
        this.$store.dispatch('setDataModalEditReview', review);
        this.$store.commit('toggleModalGlobalState', { modalName: 'editReview' });
      });
    },
    like(id) {
      if (!this.isLoadingLikeReview) {
        this.isLoadingLikeReview = true;
        this.$MS_SOCO_PUBLIC_API_URL
          .post(`/newsfeed/${id}/likes`)
          .then((response) => {
            if (response.status == 200 && response.data.success) {
              this.$store.commit('review/SET_HAS_LIKED', {
                on: this.on,
                value: response.data.data.has_liked,
                reviewId: this.reviewData._id,
              });
              if (response.data.data.has_liked) {
                this.likers.likes.unshift({
                  user: {
                    user_name: this.$store.state.auth.username,
                    image: this.$store.state.auth.userimage,
                  },
                });
                this.likers.total_likes++;
              } else {
                if (this.likers.likes.findIndex((user) => user.user_name === this.$store.state.auth.username)) {
                  this.likers.likes.splice(
                    this.likers.likes.findIndex((like) => like.user.user_name === this.$store.state.auth.username),
                    1
                  );
                }
                this.likers.total_likes--;
              }
            }
          })
          .catch((err) => {
            this.$toasted.global.error('Silahkan coba beberapa saat lagi');
          })
          .finally(() => (this.isLoadingLikeReview = false));
      }
    },
    loginOtf() {
      Auth.CentralAuth.login();
    },
    convertName(name) {
      const words = name.split('_');
      return words[0].charAt(0).toUpperCase() + words[0].slice(1) + ' ' + words.slice(1).join(' ').toLowerCase();
    },
    openModalReport() {
      this.isOpenDropdown = false;
      this.$store.commit('setOpenModal', { stateName: 'report', newVal: true });
      this.$store.commit('setNewsfeedIdOfModalReport', this.reviewData.newsfeed_id);
    },
    requestToDelete(id) {
      this.$MS_SOCO_PUBLIC_API_URL
        .delete(`/newsfeed/${id}`)
        .then((res) => {
          if (res.data.success) {
            this.$toasted.global.show('Request untuk menghapus telah dikirim');
          } else {
            this.$toasted.global.error('Silakan coba lagi dalam beberapa saat');
          }

          this.isOpenDropdown = false;
        })
        .catch((err) => {
          this.isOpenDropdown = false;
          this.$toasted.global.error('Silakan coba lagi dalam beberapa saat');
        });
    },
    toggleDropdown() {
      this.isOpenDropdown = !this.isOpenDropdown;
    },
    toggleSeeMore() {
      this.seeMoreDetailsOpen = !this.seeMoreDetailsOpen;
    },
    toggleShare(newVal) {
      if (newVal) {
        this.isOpenShareDropdown = !newVal;
      } else {
        this.isOpenShareDropdown = !this.isOpenShareDropdown;
      }
    },
    modalShare() {
      const data = { ...this.reviewData.product };
      data['is_modal_review'] = true;
      data['average_rating'] = this.reviewData.average_rating || 0;
      data['total_reviews'] = this.reviewData.product.counter_review_user || 0;
      const images = this.reviewData.product.images || this.reviewData.product.combination.images || [];
      const is_cover = images.filter((x) => x.is_cover);
      if (is_cover.length > 0) {
        data['image_cover'] = is_cover[0].url;
      } else if (!is_cover.length && images.length > 0) {
        data['image_cover'] = images[0].url;
      } else {
        data['image_cover'] = '';
      }
      this.$store.commit('setProductData', data);
      this.$store.commit('toggleModalGlobalState', { modalName: 'tellFriends' });
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.screen.isDesktop ? 'w=80' : 'w=90',
        image: src,
      });
    },
    ownerImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=30',
        image: src,
      });
    },
    showProductDetail(combination) {
      let variant = '';
      const style = 'width:18px;height:18px;border-radius:50%;margin-top:0px;padding:0;margin-right:5px;';
      if (combination.attribute) {
        Object.keys(combination.attribute)
          .sort()
          .map((attr, index) => {
            const value = combination.attribute[attr].value || '';
            // add comma to string, except if only one, or last one
            if (index > 0 && index < Object.keys(combination.attribute).length) {
              variant = `${variant} - `;
            }
            if (attr === 'shade' && value) {
              let img = '';
              if (this.isImage(value)) {
                img = `<img src="${
                  value || '/assets/img/dummy-combination.png'
                }" style="${style}" onerror="this.src='/assets/img/dummy-combination.png'" />`;
              } else {
                img = `<button style="${style}border:none;background:${value}"></button>`;
              }
              variant = variant + `${img} ${combination.attribute[attr].name}`;
            } else if (attr !== 'non_specify') {
              variant = variant + `${combination.attribute[attr].name}`;
            }
          });
      }
      return variant;
    },
    isImage(value) {
      if (value && value.search('#') !== -1 && value.length <= 7) {
        return false;
      } else {
        return true;
      }
    },
    saveSearchHistoryClicks(entity_id, entity_type) {
      if (!this.isLogin) {
        return;
      }
      const params = {
        entity_id: entity_id, // id product
        keyword: '',
        entity_type: entity_type,
      };
      return axios.post(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-clicks`, params);
    },
    comparingDate(date1, date2) {
      const created = new Date(date1);
      const updated = new Date(date2);
      if (updated > created) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.m-right {
  margin-right: 32px;
}
.mt-7 {
  margin-top: 7px;
}
.helpful-pro {
  margin-top: 16px;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 7px;
  display: flex;
}
.helpful-pro a img.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 4px;
}
.helpful-pro span.review-help-pro {
  font: 12px/23px 'lato-bold';
  color: #8c8582;
  margin-left: 2px;
  margin-right: 2px;
}
.helpful-pro .helpful-title {
  font: 12px/23px 'lato-regular';
  color: #8c8582;
}
.gray-text {
  font-family: 'Lato-Regular', sans-serif;
  font-size: 12px;
  color: #8c8582;
  text-align: left;
  line-height: 12px;
}
@media (max-width: 991px) {
  .m-right {
    margin-right: 24px !important;
    width: 150px !important;
  }
  .new-width {
    width: 130px !important;
  }
  .helpful-pro {
    margin-top: 0px !important;
  }
  #reviewProduct .card-timeline--uniform.review .card-content .right-content {
    padding-bottom: 15px !important;
  }
  .card-timeline--uniform.review.expert-review {
    border: none;
    background: #fff9fb;
    border-radius: 4px;
    .right-content {
      padding: 0;
      .trusted-review {
        position: absolute;
        margin: 0;
      }
    }
  }
  ::v-deep .global-rating-inline {
    float: left;
  }
  ::v-deep .average-rating--uniform {
    float: none !important;
  }
}
.review-text {
  font-family: $lato_regular;
  font-size: 14px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 0;
  word-break: break-word;
  .review-read-more {
    font-family: $lato_regular;
    display: block;
    color: #da2a52;
    cursor: pointer;
  }
}
.review-likes {
  .journal-icon--uniform {
    display: flex;
    align-items: center;
    height: unset;
    width: unset;
    font-family: $lato_bold;
    font-size: 13px;
    color: #8c8582;
    text-align: left;
    line-height: 13px;
    padding: 0;
    &::before {
      height: 16px;
      width: 16px;
      position: initial;
      background-size: 16px 16px;
      margin-right: 8px;
    }
    &.active {
      &::before {
        background-size: 16px 16px;
      }
    }
  }
}
.review-variant-pro:not(:empty) {
  font: 12px $lato_regular;
  margin-top: 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #f384a7;
  border-radius: 4px;
  width: max-content;
  padding: 6px 8px;
  color: #222222;
  + .desc {
    margin-top: 12px;
  }
  &.expert-review {
    background-color: #fff9fb;
  }
}
</style>
